
import React from "react";
import { motion } from "motion/react";
import {Link} from "react-router-dom";


const transition = {
  type: "spring",
  mass: 0.5,
  damping: 11.5,
  stiffness: 100,
  restDelta: 0.001,
  restSpeed: 0.001,
};

export const MenuItem = ({
  setActive,
  active,
  item,
  children,
  activeLink
}) => {
  return (
    <div onMouseEnter={() => setActive(item)} className="relative ">
      <motion.p
        transition={{ duration: 0.3 }}
        className={`cursor-pointer h6 ${activeLink ? "text-light-blue" : "text-light-title dark:text-dark-title"} transition-colors duration-200 hover:text-light-blue dark:hover:text-light-blue`}>
        {item}
      </motion.p>
      {active !== null && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={transition}>
          {active === item && (
            <div
              className="absolute top-[calc(100%_+_1.2rem)] left-1/2 transform -translate-x-1/2 pt-4">
              <motion.div
                transition={transition}
                // layoutId ensures smooth animation
                layoutId="active"
                className="bg-light-glass1 dark:bg-dark-glass1  backdrop-blur-xl rounded-2xl overflow-hidden border border-light-glassStrock2 dark:border-dark-glassStrock1 shadow-xl">
                <motion.div
                  // layout ensures smooth animation
                  layout
                  className="w-max h-full p-4">
                  {children}
                </motion.div>
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export const Menu = ({
  setActive,
  children
}) => {
  return (
    <nav
      // resets the state
      onMouseLeave={() => setActive(null)}
      className="relative rounded-full border border-transparent dark:bg-black dark:border-white/[0.2] bg-white shadow-input flex justify-center space-x-4 px-8 py-6 ">
      {children}
    </nav>
  );
};

export const ProductItem = ({
  title,
  description,
  href,
  src,
  setActive
}) => {
  return (
    <Link to={href} className=""
    onClick={() => {
      window.scrollTo(0, 0);
    }}
    onMouseLeave={() => setActive(null)}
    >
        <div className="flex flex-row items-center max-w-[18rem] justify-center gap-2">
        <img
        src={src}
        width={140}
        height={100}
        alt={title}
        className="shrink-0 rounded-md shadow-2xl" />
      <div>
        <h4 className="h6 mb-1 text-light-title dark:text-dark-title">
          {title}
        </h4>
        <p className=" caption text-light-text dark:text-dark-text">
          {description}
        </p>
      </div>
        </div>
    
    </Link>
  );
};

export const HoveredLink = ({
  children,
  ...rest
}) => {
  return (
    <a
      {...rest}
      className="text-neutral-700 dark:text-neutral-200 hover:text-black ">
      {children}
    </a>
  );
};
